module.exports = __webpack_public_path__ + "static/media/app-logo.cff59df7.svg";